var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"v-select-website",attrs:{"clearSearchOnSelect":false,"filterable":false,"searchable":false,"clearable":false,"options":_vm.websiteOptions,"name":"webOption"},on:{"input":_vm.updateStore},model:{value:(_vm.selectedWebsite),callback:function ($$v) {_vm.selectedWebsite=$$v},expression:"selectedWebsite"}})
}
var staticRenderFns = []

export { render, staticRenderFns }